<!-- components/LogPopupTemplate.vue -->
<template>
  <DxPopup
    :width="800"
    :height="620"
    :show-title="true"
    title="Log Perubahan Data"
    :drag-enabled="false"
    :hide-on-outside-click="true"
    :visible="popupLogVisible"
    @hiding="popupLogVisible = false"
  >
    <template #content>
      <template v-if="loading">
        <div class="text-center">Loading...</div>
      </template>
      <template v-else-if="logData">
        Total: {{ logData.totalCount }}
        <LogListTemplate
          :heightList="540"
          :widthList="760"
          :logData="logData.data"
        />
      </template>
    </template>
  </DxPopup>
</template>

<script>
import { DxPopup } from "devextreme-vue/popup";
import LogListTemplate from "./LogListTemplate.vue";
import api from "@/api";

export default {
  name: "LogPopupTemplate",
  components: { DxPopup, LogListTemplate },
  data() {
    return {
      popupLogVisible: false,
      logData: null,
      loading: false,
    };
  },
  methods: {
    async showAll(parentType, parentId, showGajiPeriode = false) {
      if (!parentId) return;
      await this.fetchLog(null, null, parentType, parentId, showGajiPeriode);
    },

    async showBySubject(e, logName, parentType = null, parentId = null) {
      let rowId = null;
      if (typeof e === "string" || typeof e === "number") {
        rowId = e;
      } else {
        rowId = e.row.key;
      }
      if (!rowId) return;
      await this.fetchLog(rowId, logName, parentType, parentId);
    },

    async fetchLog(id, logName, parentType, parentId, showGajiPeriode = false) {
      try {
        this.loading = true;
        this.popupLogVisible = true;
        const response = await api.post("/get-log", {
          log_name: logName,
          subject_id: id,
          parent_type: parentType,
          parent_id: parentId,
          show_gaji_periode: showGajiPeriode,
        });
        this.logData = response.data;
      } catch (error) {
        console.error("Log get failed:", error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
